import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Phase 3 §3 — inactive-account interceptor. The strict-dep on EVERY
// protected route returns 403 with detail "Account inactive — contact
// support" once an admin flips a user's status. The lenient /auth/me
// keeps working (surfaces status="suspended") so AuthContext can
// re-hydrate the splash. This handler bridges the axios layer with
// the React layer: AuthContext registers `refreshMe` on mount; the
// interceptor calls it on the first 403 of this shape so the
// <InactiveAccountSplash> takes over without waiting for the next
// route change. Toast is suppressed because the splash IS the
// feedback.
let inactiveHandler = null;
export function registerInactiveAccountHandler(fn) {
  inactiveHandler = fn;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error?.response?.data?.detail;
    const isInactive403 =
      error?.response?.status === 403 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("account inactive");
    if (isInactive403 && inactiveHandler) {
      // Fire-and-forget — refreshMe handles its own errors.
      try {
        inactiveHandler();
      } catch {
        /* never block the rejection chain */
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
